import React, { useState } from 'react'
import styled from 'styled-components'
import { useRouter } from 'next/router'
import { TriggerExceptTarget } from 'components/misc/trigger'
import { DashboardDropdownMenu } from 'components/misc/header/dashboard/dashboard-dropdown-menu'
import {
  MobileTabMenu,
  MobileTabMenuContainer,
  MobileTabMenuText,
} from 'components/misc/header/styles'
import { Chat } from 'components/misc/header/dashboard/dashboard-chat'
import { AlertBadge } from 'components/common/badge'
import { useDashboardApplicationsSummary, useStartupUser } from 'apis/hooks'
import { sumApplicantCount } from 'utils/formatters'

export const DashboardMobileHeaderTabs = () => {
  const router = useRouter()
  const { data: user } = useStartupUser()
  const { data: summary } = useDashboardApplicationsSummary()
  const [isMoreDropdownOpen, setIsMoreDropdownOpen] = useState(false)
  const isScoutSelected = router.asPath.includes('/scouts')
  const isApplicantSelected = router.asPath.includes('/applicants')
  const isPositionSelected = router.asPath.includes('/positions')
  const isRecommendedSelected = router.asPath.includes('/recommended')
  const isMoreSelected =
    router.asPath.includes('/startup') ||
    router.asPath.includes('/account') ||
    router.asPath.includes('/pricing')
  const isChatSelected = router.asPath.includes('/chat-rooms')
  const applicantCount = sumApplicantCount(summary || [])
  const newRecommendedCount =
    !!user?.curationUpdate && user.curationUpdate.newCuratedScoutRequestCount

  return (
    <MobileTabMenuContainer style={{ gap: 16 }}>
      <MobileTabMenu
        onClick={() => router.push('/dashboard/scouts/search/start')}
      >
        <DashboardMobileTabMenuText isSelected={isScoutSelected}>
          스카우트
        </DashboardMobileTabMenuText>
      </MobileTabMenu>
      <MobileTabMenu onClick={() => router.push('/dashboard/recommended')}>
        <DashboardMobileTabMenuText
          isSelected={isRecommendedSelected}
          style={{ position: 'relative' }}
        >
          {!!newRecommendedCount && (
            <AlertBadge size={10} top={-4} right={-6} />
          )}
          매니저추천
        </DashboardMobileTabMenuText>
      </MobileTabMenu>
      <MobileTabMenu onClick={() => router.push('/dashboard/applicants')}>
        <DashboardMobileTabMenuText
          isSelected={isApplicantSelected}
          style={{ position: 'relative' }}
        >
          {applicantCount > 0 && <AlertBadge size={10} top={-4} right={-6} />}
          지원자
        </DashboardMobileTabMenuText>
      </MobileTabMenu>
      <MobileTabMenu onClick={() => router.push('/dashboard/positions')}>
        <DashboardMobileTabMenuText isSelected={isPositionSelected}>
          채용 공고
        </DashboardMobileTabMenuText>
      </MobileTabMenu>
      <TriggerExceptTarget onTrigger={() => setIsMoreDropdownOpen(false)}>
        <MobileTabMenu onClick={() => setIsMoreDropdownOpen((prev) => !prev)}>
          <DashboardMobileTabMenuText isSelected={isMoreSelected}>
            더보기
          </DashboardMobileTabMenuText>
          {isMoreDropdownOpen && <DashboardDropdownMenu />}
        </MobileTabMenu>
      </TriggerExceptTarget>
      <MobileTabMenu>
        <DashboardMobileTabMenuText isSelected={isChatSelected}>
          <Chat />
        </DashboardMobileTabMenuText>
      </MobileTabMenu>
    </MobileTabMenuContainer>
  )
}

const DashboardMobileTabMenuText = styled(MobileTabMenuText)`
  height: 40px;
  font-size: 14px;
  min-width: auto;
`
